import { z } from "zod";
// ─── Auth ────────────────────────────────────────────────────────────────────
export const LoginSchema = z.object({
    username: z.string().min(1, "Username is required"),
    password: z.string().min(1, "Password is required"),
});
export const JwtPayloadSchema = z.object({
    sub: z.string(),
    username: z.string(),
    clientId: z.number().int().positive(),
    role: z.enum(["ADMIN", "OPERATOR", "DEVELOPER"]),
    tokenVersion: z.number().int().nonnegative(),
    iat: z.number().optional(),
    exp: z.number().optional(),
});
// ─── User ────────────────────────────────────────────────────────────────────
export const UserRoleSchema = z.enum(["ADMIN", "OPERATOR", "DEVELOPER"]);
export const CreateUserSchema = z.object({
    username: z.string().min(3).max(50),
    email: z.string().email(),
    password: z.string().min(8, "Password must be at least 8 characters"),
    role: UserRoleSchema,
});
// ─── Battery Model ────────────────────────────────────────────────────────────
export const CreateBatteryModelSchema = z.object({
    name: z.string().min(1, "Model name is required").max(100),
    voltage: z.number().positive(),
    secondaryVoltage: z.number().nonnegative().optional(),
    capacityMah: z.number().positive(),
    sensorType: z.string().optional(),
    collectSerial: z.boolean().default(false),
    approvalThreshold: z.number().min(0).max(100),
    rejectionThreshold: z.number().min(0).max(100),
    description: z.string().optional(),
});
export const UpdateBatteryModelSchema = CreateBatteryModelSchema.partial();
// ─── Battery Test Result ──────────────────────────────────────────────────────
export const BatteryStatusSchema = z.enum([
    "GOOD",
    "HALF",
    "DEFECT",
    "RECARGA",
]);
export const CreateBatteryTestSchema = z.object({
    serialNumber: z.string().min(1),
    equipmentId: z.string().min(1),
    measuredMah: z.number().nonnegative(),
    internalResistance: z.number().nonnegative().optional(),
    configuredMah: z.number().nonnegative(),
    description: z.string().optional(),
});
// ─── Pagination ───────────────────────────────────────────────────────────────
export const PaginationQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
    cursor: z.string().optional(),
});
//# sourceMappingURL=index.js.map